const TOKEN_SESSION_STORAGE_KEY = "GraphQLToken";
const USER_DATA_SESSION_STORAGE_KEY = "UserData";
const MIN_PASSWORD_LENGTH = 10;

export {
  TOKEN_SESSION_STORAGE_KEY,
  USER_DATA_SESSION_STORAGE_KEY,
  MIN_PASSWORD_LENGTH,
};
